import { Divider, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ApiContext } from "../../ApiContext";
import { PopoverBase } from "./PopoverBase";

import { ColorScheme } from "../../../Themes/ColorScheme";
import { UserContext } from "../../UserContext";
import { StyledLinkButton } from "../SidebarMenu/StyledLinkButton";
import { LocationSelector } from "./LocationSelector";

export const TopBar = () => {
	const debug = false;

	const { user, title } =
		useContext(UserContext);
	const { t } = useTranslation();
	const { ApiCall } = useContext(ApiContext);

	const [invites, setInvites] = useState(false);
	const [openPopover, setOpenPopover] = useState(null);
	const [popoverContent, setPopoverContent] = useState(null);

	const handleClose = () => {
		setOpenPopover(null);
	};

	const handlePopover = (props) => {
		setOpenPopover(props.currentTarget);
	};

	const handlePopoverContent = (props) => {
		setPopoverContent(props);
	};

	const open = Boolean(openPopover);
	const id = open ? "popover-menu" : undefined;

	useEffect(() => {
		if (user == null) {
			return;
		}

		ApiCall("GET", "client/invites")
			.then((res) => {
				if (res.length > 0) setInvites(true);
			})
			.catch((error) => {
				if (debug) console.log(error);
			});
	}, [user]);

	useEffect(() => {
		if (user == null) {
			return;
		}
		ApiCall("GET", "client/access_requests").then((res) => {
			if (res.length > 0) setInvites(true);
		});
	}, [user]);

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			alignItems="center"
			spacing={4}
			sx={{
				width: 1,
				height: "fit-content",
				padding: "5px",
				paddingTop: isDesktop ? "30px" : "8px",
				paddingBottom: "5px",
				borderBottom: "1px solid " + ColorScheme.secondary + ColorScheme.opacity25
			}}
		>
			<Stack
				direction="column"
				alignItems="flex-start"
				justifyContent="space-between"
			>
				<Stack direction="row" alignItems="center" spacing={2}>
					<Typography
						style={{ fontSize: isMobile ? "20px" : "30px" }}
					>
						{title}
					</Typography>
				</Stack>

				{user != null && <LocationSelector />}
			</Stack>

			<Stack
				direction="row"
				spacing={isMobile ? 2 : 0.5}
				alignItems="center"
			>
				{!isMobile && (
					<Stack>
						<Typography
							style={{
								marginRight: "20px",
								fontSize: "16px",
								fontWeight: "700"
							}}
						>
							{user != null && user.name}
						</Typography>

						<Typography
							style={{
								marginRight: "20px",
								fontSize: "12px",
							}}
						>
							{user != null && user.email}
						</Typography>
					</Stack>
				)}
				<StyledLinkButton
					current_path={location.pathname.split("/")[1]}
					path="settings"
					title={t("common.settings")}
					ignoreStyling={true}
					isPopover={true}
					hasTooltip={true}
					togglePopover={handlePopover}
					handlePopoverContent={handlePopoverContent}
				/>

				{!isMobile && (
					<Divider
						orientation="vertical"
						sx={{
							backgroundColor: ColorScheme.secondary + ColorScheme.opacity25,
							width: "1px",
							height: "50px",
							border: "0px solid"
						}}
					/>
				)}

				<StyledLinkButton
					current_path={location.pathname.split("/")[1]}
					path="messages"
					title={t("common.messages")}
					hasBadge={invites}
					hasTooltip={true}
					ignoreStyling={true}
					isPopover={true}
					togglePopover={handlePopover}
					handlePopoverContent={handlePopoverContent}
				/>
			</Stack>
			<PopoverBase
				id={id}
				open={open}
				content={popoverContent}
				handleClose={handleClose}
				anchorEl={openPopover}
			/>
		</Stack>
	);
};
